import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close_bai.png'
import _imports_1 from '@/assets/offers/deposit_promotions_iconcoin.png'


const _hoisted_1 = { class: "pop_container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "popText" }
const _hoisted_4 = { class: "btn_container" }

import { rechargeActivity } from '@/api/offers'
import StatusPopup from '@/components/common/statusPopup.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import MainButton from '../../components/common/mainButton.vue'
import { useUserStore } from '@/stores/user'
interface DataItem {
    recharge: string,
    reward: string,
    turnover: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'depositPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const activityData = ref<DataItem>({
    recharge: "",
    reward: "",
    turnover: ""
})
const userStore = useUserStore()
const depositValue = ref(0)
const rewardValue = ref(0)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const router = useRouter()
const open = (data: any) => {
    show.value = true
    activityData.value = data
    depositValue.value = Number(data.recharge)
    rewardValue.value = Number(data.reward)
}
const close = () => {
    show.value = false
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const submitDeposit = () => {
    userStore.setRechargeBonusType(5)
    localStorage.setItem('footerPopupOpen', '2')
    router.push({
        path: '/',
        query: { value: depositValue.value }
    })

}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    style: {
        minWidth: '100%',
        minHeight: '60%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "close_icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: close
          })
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "head_icon" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.deposite')), 1),
        _createVNode(_component_van_row, { class: "valueContainer" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "2",
              class: "currencyText"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("R$")
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "20",
              class: "amount"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(depositValue.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t('offers.depositPopText', {
                    recharge: depositValue.value, reward: rewardValue.value
                })) + " ", 1),
          _createElementVNode("span", null, "R$ " + _toDisplayString(depositValue.value + rewardValue.value), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MainButton, {
            title: _ctx.$t('common.deposite'),
            onclick: submitDeposit,
            activeStatus: true
          }, null, 8, ["title"])
        ])
      ]),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        "is-show-success": isSuccess.value,
        content: toastContent.value
      }, null, 8, ["is-show-success", "content"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})